import React, { useEffect, useState } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { ResetDefaultPassword } from '../../../../modules/auth/core/_requests'
import clsx from 'clsx'
import { useAuth } from '../../../../modules/auth/core/Auth'

type Props = {
  show: boolean
  handleClose: () => void
}

const ResetSchema = Yup.object().shape({

  Password: Yup.string()
    .required("No Password Given")
    .min(
      8,
      'password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special'
    )
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      "Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character"
    )
  ,
  ConfirmPassword: Yup.string().oneOf([Yup.ref('Password')], 'Passwords must match')
})

const ResetPasswordModal: React.FC<Props> = ({ show, handleClose }) => {
  useEffect(() => {
    initMap()
  }, [])

  //const [location, setLocation] = useState(data.location)
  const dissmissLocation = () => {
    //setLocation(data.location)
    handleClose()
  }

  const initMap = () => { }

  const initialValues = {
    Password: '',
    ConfirmPassword: ''
  }
  const username = useAuth().currentUser?.UserName!
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: ResetSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(async () => {
        //let request : ForgotPasswordRequest = {loginID : values.email}
        var data = await ResetDefaultPassword(username, values.ConfirmPassword)
          // eslint-disable-next-line no-empty-pattern
          .then(({ data: { } }) => {
            setHasErrors(false)
            setLoading(false)
            window.location.reload();
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('Error')
          })
        setStatus(data);
      }, 1000)
    },
  })

  return (
    <Modal
      className='modal fade'
      id='kt_modal_reset'
      data-backdrop='static'
      data-keyboard='false'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName=' modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Change Password</h5>

          
        </div>
        <div className='modal-body'>
          <Row>
            <Col xs={12} md={12}>
              <form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                noValidate
                id='kt_default_Password_Change_form'
                onSubmit={formik.handleSubmit}
              >

                {/* begin::Form group Password */}
                <div className='fv-row mb-7 hidden'>
                  <label className='form-label fw-bolder text-dark fs-6'>New Password</label>
                  <input
                    placeholder='Password'
                    type='password'
                    autoComplete='off'
                    {...formik.getFieldProps('Password')}
                    className={clsx(
                      'form-control  form-control-solid',
                      { 'is-invalid': formik.touched.Password && formik.errors.Password },
                      {
                        'is-valid': formik.touched.Password && !formik.errors.Password,
                      }
                    )}
                  />
                  {formik.touched.Password && formik.errors.Password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.Password}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group Confirm Password  */}
                <div className='fv-row mb-7 hidden'>
                  <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>
                  <input
                    placeholder='Confirm Password'
                    type='password'
                    autoComplete='off'
                    {...formik.getFieldProps('ConfirmPassword')}
                    className={clsx(
                      'form-control  form-control-solid',
                      { 'is-invalid': formik.touched.ConfirmPassword && formik.errors.ConfirmPassword },
                      {
                        'is-valid': formik.touched.ConfirmPassword && !formik.errors.ConfirmPassword,
                      }
                    )}
                  />
                  {formik.touched.ConfirmPassword && formik.errors.ConfirmPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.ConfirmPassword}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
                {/* begin::Form group */}
                <div className='text-center'>
                  <button
                    type='submit'
                    id='kt_sign_up_submit'
                    className='btn btn-lg btn-primary w-100 mb-5'
                    disabled={formik.isSubmitting || !formik.isValid }
                  >
                    {!loading && <span className='indicator-label'>Update Password</span>}
                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
                {/* end::Form group */}
              </form>
            </Col>
          </Row>
        </div>

      </div>
    </Modal>
  )
}

export { ResetPasswordModal }
